import Component from '@glimmer/component';
import { getOwner } from '@ember/application';
import { sanitizeHtml } from 'beebee-helper/helpers/safe-string';
import { isCustomFieldEmpty } from '../lib/custom-field-empty.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if (and this.isNuova this.isEmpty)}}\n  <span class=\'nv-fact-v--empty\' data-test-nv-cf-empty>—</span>\n{{else if (is-equal @custom_field.organization_custom_field.data_type \'date\')}}\n  {{#if @custom_field.value}}\n    {{format-date @custom_field.value}}\n  {{/if}}\n{{else if (is-equal @custom_field.organization_custom_field.data_type \'currency\')}}\n  {{#if (not-eq @custom_field.number_value null)}}\n    {{format-euro @custom_field.number_value}}\n  {{/if}}\n{{else if (is-equal @custom_field.organization_custom_field.data_type \'number\')}}\n  {{@custom_field.number_value}}\n{{else if (is-equal @custom_field.organization_custom_field.data_type \'range\')}}\n  {{@custom_field.number_value}}\n{{else if (is-equal @custom_field.organization_custom_field.data_type \'checkbox\')}}\n  {{#if @custom_field.boolean_value}}\n    {{t \'yes\'}}\n  {{else}}\n    {{t \'no\'}}\n  {{/if}}\n{{else if (is-equal @custom_field.organization_custom_field.data_type \'advancedTextarea\')}}\n  {{this.advancedTextarea}}\n{{else if (is-equal @custom_field.organization_custom_field.data_type \'table\')}}\n  <CfTable\n    @custom_field={{@custom_field}}\n    @rangeOption={{@rangeOption}}\n    @applicationController={{@applicationController}}\n  />\n{{else if (is-equal @custom_field.organization_custom_field.data_type \'calculated\')}}\n  {{@custom_field.number_value}}\n{{else}}\n  {{@custom_field.value}}\n{{/if}}");

/**
 * MAP (in-file navigation graph — keep in sync with code):
 *   role:      component (read-only render of a filled-in custom_field value, dispatched
 *              by data_type)
 *   extends:   Component (@glimmer)
 *   template:  custom-field-value.hbs (colocated)
 *   args:      @custom_field (reads .value + .organization_custom_field.data_type); template
 *              also forwards @rangeOption/@applicationController to <CfTable>
 *   uses:      beebee-helper/helpers/safe-string (sanitizeHtml), lib/custom-field-empty (isEmpty), child <CfTable>,
 *              {{format-date}} / {{format-euro}} / {{t}} helpers
 *   siblings:  view-custom-field (label+value wrapper that renders this), edit-custom-field
 *   tests:     tests/unit/components/custom-field-value-test.js,
 *              tests/integration/components/custom-field-value-test.js
 *   gotchas:
 *     - advancedTextarea value is raw stored HTML — run through sanitizeHtml before it is
 *       rendered; do not print custom_field.value directly.
 */
class CustomFieldValueComponent extends Component {
  /** UI nuova on (optional lookup: apps / dummies without beebee-base-template have no `ui-is-nuova` helper) */
  get isNuova() {
    return Boolean(getOwner(this)?.lookup?.('service:ui')?.isNuova);
  }

  /**
   * Nothing to show for this field (UI nuova prints «—» instead of an empty value cell: RULES_V2 §3 never an empty
   * area). THE definition lives in lib/custom-field-empty.js (shared with lib/custom-field-layout.js).
   */
  get isEmpty() {
    return isCustomFieldEmpty(this.args.custom_field);
  }
  get advancedTextarea() {
    return this.args.custom_field.organization_custom_field?.data_type === 'advancedTextarea' ? sanitizeHtml(this.args.custom_field.value) : null;
  }
}
setComponentTemplate(TEMPLATE, CustomFieldValueComponent);

export { CustomFieldValueComponent as default };
//# sourceMappingURL=custom-field-value.js.map
